export const SET_BOOKING = 'SET_BOOKING';
// export const UPDATE_BOOKING_FROM_SEARCH = 'BOOKING_FROM_SEARCH';
export const FETCH_BOOKING_EXTRAS = 'BOOKING_EXTRAS';
export const FETCH_FLEX_EXTRAS = 'FETCH_FLEX_EXTRAS';
export const SELECT_BOOKING_EXTRA = 'SELECT_BOOKING_EXTRA';
export const SET_BOOKING_EXTRA_QUANTITY = 'SET_BOOKING_EXTRA_QUANTITY';
export const SET_BOOKING_LOADING = 'SET_BOOKING_LOADING';
export const SET_RESERVATION = 'SET_RESERVATION';
export const SET_BOOKING_PASSENGERS = 'SET_BOOKING_PASSENGERS';
export const REDSYS_RETRIEVE_PARAMS = 'REDSYS_RETRIEVE_PARAMS';
export const RETREIVE_RESERVATION = 'RETREIVE_RESERVATION';
export const SET_DOCUMENT_NEED = 'SET_DOCUMENT_NEED';
export const RETREIVE_DATA_EXTRAS_STEP = 'RETREIVE_DATA_EXTRAS_STEP';
